import React from 'react';
import { Container, Dot, Label, KindBadge } from './ActivityIndicator.styled';

/**
 * ActivityIndicator - Pulsing dot + label + kind badge.
 * Renders when currentActivity is non-null during streaming.
 */
const ActivityIndicator = ({ activity }) => {
  if (!activity) return null;

  const { label, kind } = activity;

  return (
    <Container>
      <Dot aria-hidden />
      <Label>{label ?? 'Processing...'}</Label>
      {kind && <KindBadge>{kind}</KindBadge>}
    </Container>
  );
};

export default ActivityIndicator;
